import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import BaseComponent from '../../../baseClasses/BaseComponent';
import TableRow from '../../../components/Table/TableRow';
import documentIcon from '../../../assets/images/document-icon-light-gray.svg';
import TableHeader from '../../../components/Table/TableHeader';
import dataModel from '../../../models/DataModel';

import './ReferenceDocumentsTable.scss';

// Change ReferenceDocumentsTable to the appropriate name
class ReferenceDocumentsTable extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      sortedType: this.props.sortField,
      sortAsc: this.props.ascending,
    };
  }

  componentDidUpdate(prevProps) {
    const nextProps = this.props;
    if (nextProps.accent != prevProps.accent) {
      this.setState({ accent: nextProps.accent });
    }
    if (nextProps.referenceDocuments != prevProps.referenceDocuments && nextProps.referenceDocuments) {
      this.infiniteDone = false;
    }
    else if (nextProps.filterCleared != prevProps.filterCleared) {
      this.infiniteDone = false;
    }
  }

  handleScrolling() {
    const listRect = this.list.getBoundingClientRect();
    const scrollRect = this.scroller.getBoundingClientRect();
    if (!this.infiniteDone &&
      listRect.bottom <= scrollRect.bottom + 12 &&
      !this.scrollinProgress &&
      ((this.props.referenceDocuments && this.props.referenceDocuments.length < this.props.totalReferenceDocuments))) {
      this.scrollinProgress = true;
      this.setState({ loadingMore: true });

      if (this.props.getMoreReferenceDocuments) {
        this.props.getMoreReferenceDocuments(
          (fetchedDocuments) => {
            if (this.props.referenceDocuments.length >= this.props.totalReferenceDocuments) {
              this.infiniteDone = true;
            }
            this.handledLoadMoreOnTransition = false;
            this.scrollinProgress = false;
            this.setState({ loadingMore: false });
          }
        );
      }
    }
  }

  handleSort(type, direction) {
    this.infiniteDone = false;
    if (this.props.referenceDocuments && this.props.referenceDocuments.length > 0) {
      if (type == this.state.sortedType && direction == 'up' && this.state.sortAsc) {
        this.setState({ sortedType: null });
        this.infiniteDone = false;
        this.props.handleSortChange(null, null);
      }
      else if (type == this.state.sortedType && direction == 'down' && !this.state.sortAsc) {
        this.setState({ sortedType: null });
        this.infiniteDone = false;
        this.props.handleSortChange(null, null);
      }
      else {
        this.props.handleSortChange(type, direction == 'up' ? true : false);
        this.infiniteDone = false;

        this.setState({
          sortedType: type,
          sortAsc: direction == 'up' ? true : false,
        });
      }
    }
  }

  handleAddButtonClicked() {
    this.props.history.push('/directory');
  }

  handleSelectReferenceDocument(referenceDocument) {
    if (this.props.selectReferenceDocument) {
      this.props.selectReferenceDocument(referenceDocument);
    }
  }

  handleDeleteReferenceDoc(e, doc){
    dataModel.showGlobalModal('SYSTEM_POPUP', {
      width: 320,
      height: 184,
      message: 'Are you sure you want to delete this Reference Document?',
      cancelButtonText: 'No',
      okButtonText: 'Yes',
      handleOwnerOk: () => {
        dataModel.referenceDocumentsDAO.deleteReferenceDocument(doc.id).then((res) => {
          if (res != null){
            this.props.handleDeleteDocument(doc.id);
          }
        });
      },
    });
  }

  handleCreateUserRows() {
    let even = false;
    let rows = this.props.referenceDocuments ? this.props.referenceDocuments.map(
      referenceDocument => {
        even = !even;
        return (
          <TableRow
            key={referenceDocument.id}
            selectedItem={referenceDocument}
            even={even}
            select={this.handleSelectReferenceDocument}
            deleteHandler={this.handleDeleteReferenceDoc}
            type={'reference-documents'}
          />
        );
      }
    ) : null;
    return rows;
  }

  // handleCaretSelection(direction) {
  //   this.direction = direction
  // }

  handleSetScroller(element) {
    if (element) {
      this.scroller = element;
      this.scroller.addEventListener('scroll', this.handleScrolling);
    }
  }

  handleSetList(element) {
    this.list = element;
  }

  render() {
    let { accent, hasBannerDisplay } = this.props;
    const sortDirectionClass = this.state.sortAsc ? '' : 'down';

    let caretTypes = [
      { type: 'name', headerName: 'DOCUMENT NAME', first: true },
      { type: 'attachment_content_type', headerName: 'DOCUMENT TYPE' },
      { type: 'uploaded_by', headerName: 'UPLOADED BY' },
      { type: 'created_at', headerName: 'UPLOADED DATE' },
      { type: 'market', headerName: 'MARKET' },
      { type: 'tasks', headerName: 'TASK NUMBER' },
      { type: 'version_count', headerName: 'VERSIONS' },
    ];

    let tableHeader = (
      <TableHeader
        accent={accent}
        sortDirectionClass={sortDirectionClass}
        handleSort={this.handleSort}
        sortedType={this.state.sortedType}
        caretTypes={caretTypes}
        reportType={'reference-documents'}
      />
    );

    let documentRows = this.handleCreateUserRows();
    let loadingMore = null;

    if (this.state.loadingMore) {
      loadingMore = <div className="loading-more-indicator">Loading More...</div>;
    }

    if (!this.props.inProgress && (!documentRows || documentRows.length == 0)) {
      if (this.props.filter || this.props.searchString) {
        documentRows = <div className="no-matches-indicator">No Documents Found...</div>;
      }
      else if (!this.props.refresh) {
        let noDocumentsText = <div className="no-documents">There are no Reference Documents for this company.</div>;
        documentRows = <div className='no-documents-container'>
          <img className='document-icon' src={documentIcon} alt='icon' />
          {noDocumentsText}
        </div>;
      }
    }

    return <div className='reference-documents-table'>
      {tableHeader}
      <div
        className={`reference-documents-scroller${hasBannerDisplay ? '' : ' infinite-scrolling'}`}
        ref={(element) => { this.handleSetScroller(element); }}
      >
        <div className='reference-documents-rows' ref={(element) => { this.handleSetList(element); }}>
          {documentRows}
          {loadingMore}
        </div>
      </div>
    </div>;
  }
}

// Change to appropriate class name

const mapStateToProps = (state, ownProps) => {
  let accent = state.new_companies.currentCompany ? state.new_companies.currentCompany.accent_color : null;

  return {
    dataModel: dataModel,
    permissions: state.new_users.permissions,
    accent: accent,
    totalReferenceDocuments: state.referenceDocuments.totalReferenceDocuments,
    currentCompany: state.new_companies.currentCompany,
    currentUser: state.new_users.currentUser,

  };
};

// For handling state change from a dispatch
const mapDispatchToProps = (dispatch) => {
  return {
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ReferenceDocumentsTable));



// WEBPACK FOOTER //
// ./src/containers/ReferenceDocumentsLibrary/ReferenceDocumentsTable/index.js